const styles = theme => ({
  chartContainer: {
    marginTop: '16px',
    marginBottom: '8px',
  },
  tooltip: {
    background: '#fff',
    border: '1px solid #ccc',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '13px',
  },
  tooltipLabel: {
    margin: '0 0 6px 0',
    fontWeight: 600,
  },
  tooltipEntry: {
    margin: '2px 0',
  },
});

export default styles;
